import React from 'react';
import {getConsistentColor, getInitial} from '../../utils/profile-picture-utils';

type ProfilePictureProps = {
  name: string;
  url?: string;
};

const ProfilePicture: React.FC<ProfilePictureProps> = ({name, url}) => {
  if (url) {
    return (
      <div className="w-24 h-24 rounded-full overflow-hidden shadow-md">
        <img src={url} alt={`${name}'s profile`} className="w-full h-full object-cover" />
      </div>
    );
  }

  return (
    <div
      className="w-24 h-24 rounded-full flex justify-center items-center text-white text-5xl font-semibold"
      style={{backgroundColor: getConsistentColor(name)}}>
      {getInitial(name)}
    </div>
  );
};

export default ProfilePicture;
